export const BILLING_SERVICE_REPORT_TEAM_COMPETENCE = 'corp-report-team-competence';
export const BILLING_SERVICE_REPORT_WEAK_LINK = 'corp-report-weak-link';
export const BILLING_SERVICE_REPORT_ADAPTATION = 'corp-report-adaptation';
export const BILLING_SERVICE_REPORT_BY_TEAM = 'corp-report-by-team';
export const BILLING_SERVICE_REPORT_BY_PERSON = 'corp-report-by-person';